import React from 'react';
import PropTypes from "prop-types";
import BasicCard from '../../core/Cards/BasicCard';
import FileTableList from '../../core/File/FileTable';
import { APP_TERMS } from '../../../app-terms';

const RadiologistFilesTableField = ({ caseId, value = [], onChange }) => {

  const handleFileDelete = (record) => {
    const newFiles = value?.filter((f) => f.uid !== record?.uid);
    onChange?.(newFiles);
  };

  return (
    <BasicCard
      size="small"
      style={{ height: '100%' }}
      title={`${APP_TERMS.generic_radiologist} ${APP_TERMS.generic_report}`}
    >
      <FileTableList
        dataSource={value}
        caseId={caseId}
        showActions
        onFileDelete={handleFileDelete}
        fileNameIndex={'name'}
        fileObjectKeyIndex={'uid'}
        fileSize={'size'}
      />
    </BasicCard>
  );
};

RadiologistFilesTableField.propTypes = {
  onChange: PropTypes.func,
  id: PropTypes.string,
  caseId: PropTypes.number,
  value: PropTypes.any,
};

export default RadiologistFilesTableField;
